export default __webpack_public_path__ + "assets/06255b10184f017780ccfb76267a8543.png";